var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnlineSession(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 7.44313C18.3337 6.93829 18.3337 6.68586 18.2338 6.56898C18.1472 6.46756 18.0173 6.41373 17.8843 6.4242C17.7311 6.43626 17.5526 6.61475 17.1956 6.97173L14.167 10.0003L17.1956 13.0289C17.5526 13.3859 17.7311 13.5644 17.8843 13.5765C18.0173 13.5869 18.1472 13.5331 18.2338 13.4317C18.3337 13.3148 18.3337 13.0624 18.3337 12.5575V7.44313Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 8.16699C1.66699 6.76686 1.66699 6.0668 1.93948 5.53202C2.17916 5.06161 2.56161 4.67916 3.03202 4.43948C3.5668 4.16699 4.26686 4.16699 5.66699 4.16699H10.167C11.5671 4.16699 12.2672 4.16699 12.802 4.43948C13.2724 4.67916 13.6548 5.06161 13.8945 5.53202C14.167 6.0668 14.167 6.76686 14.167 8.16699V11.8337C14.167 13.2338 14.167 13.9339 13.8945 14.4686C13.6548 14.939 13.2724 15.3215 12.802 15.5612C12.2672 15.8337 11.5671 15.8337 10.167 15.8337H5.66699C4.26686 15.8337 3.5668 15.8337 3.03202 15.5612C2.56161 15.3215 2.17916 14.939 1.93948 14.4686C1.66699 13.9339 1.66699 13.2338 1.66699 11.8337V8.16699Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineSession);
export default __webpack_public_path__ + "static/media/OnlineSession.a646819895b48a9af37c18519338ee18.svg";
export { ForwardRef as ReactComponent };